import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function NotFound() {
  return (
    <div className="min-h-screen grain-bg">
      <Navbar />
      <div className="pt-32 pb-24 max-w-xl mx-auto px-5 text-center" data-testid="not-found-page">
        <img src="/logo-mark.png" alt="Rally Love" className="w-20 mx-auto mb-6 opacity-70" />
        <div className="pill-badge inline-flex mb-4">ERRORE 404</div>
        <h1 className="headline-huge text-4xl sm:text-5xl mb-4">Fuori strada.</h1>
        <p className="text-slate-400 mb-8">La pagina che cerchi non esiste o è stata spostata.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-crimson" data-testid="not-found-home">TORNA ALLA HOME</Link>
          <Link to="/paddock" className="btn-outline-rl" data-testid="not-found-paddock">VAI AI RALLY</Link>
        </div>
      </div>
    </div>
  );
}
